import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import Leaderboard from "../partials/exchange/Leaderboard";
import Participant from "../partials/exchange/Participant";
import { toast, Toaster } from "react-hot-toast";
import * as myConstList from "../../BaseUrl";
import socketIOClient from "socket.io-client";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;
const jwtToken = localStorage.getItem("jwtToken");
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
const config = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
class TradingContest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      leaderboard: [],
      participant: [],
      contestLogo: "",
      contestName: "",
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      entryFee: "",
      virtualFund: "",
      winningAmount: "",
      winningAmountInUsd: "",
      winning_distribution_type: "",
      contestStatus: "",
      levels: [],
      winningPrize: [],
      description: "",
      heading: "",
      about: "",
      notes: "",
      pair_id: "",
      numOfParticipation: "",
      contestId: this.props.match.params.id,
      id: this.props.match.params.id,
      currentStatus: "",
      currentStatusLive: "",
      pairRealName: "",
      max_particepate: "",
      playNow: "",
      checked: false,
      bonusper: 0,
      bonus: 0,
      contestType: "",
      contestTypePast: "",
      cashWalletChecked: false,
      winningWalletChecked: false,
      rewardWalletChecked: false,
      cashWalletDeduct: 0,
      winningWalletDeduct: 0,
      rewardWalletDeduct: 0,
      participateBtnDisable: false,
      couponRequired: "",
      contestTypeStatus: "",
      exchangeType: "",
      urltemp: "",
      winninghideshow: "",
      contestCreateType: "",
      predictionOrder: [],
      exchangePageUrl: "",
      winning_distribution_type: "",
      winningCash: 0,
      bufferTime: "",
      priceDistributionDateTime: "",
      remainingPriceDistribution: "",
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    document.body.classList.add("traading-contest-page");
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
    this.getData();
  }

  // componentWillReceiveProps(nextProps) {
  //     this.getData()
  // }
  participatedata(data) {
    var endDate = new Date(data.endDate);
    endDate = endDate.toString();
    var startDate = new Date(data.startDate);
    startDate = startDate.toString();
    window.webengage.track("Participation Started", {
      "Category Name": "Live",
      "Contest Name": data.contestName,
      "Prize pool": data.winningAmount,
      "Started At": new Date(startDate),
      "Ends in": new Date(endDate),
      "Number of participants": Number(data.numOfParticipation),
    });
    this.setState({
      id: this.props.match.params.id,
      entryFee: data.entryFee,
      virtualFund: data.virtualFund,
      max_particepate: data.max_particepate,
      couponRequired: data.couponRequired,
      poitsRequire: data.entryFeePoints,
      isEntryFees: data.isEntryFees,
      entryFeeTypeRequired: data.entryFeeTypeRequired,
      contestType: data.contestType,
    });
  }
  participatedata22(data) {
    var id = this.props.match.params.id;

    this.setState({
      id: data.id,
      entryFee: data.entryFee,
      virtualFund: data.virtualFund,
      max_particepate: data.max_particepate,
      couponRequired: data.couponRequired,
      poitsRequire: data.entryFeePoints,
      entryFeeTypeRequired: data.entryFeeTypeRequired,
      contestType: data.contestType,
    });
    if (data.isEntryFees === "yes") {
      this.setState({ isEntryFeesModaL: true });
    } else {
      this.participate22(id, data.virtualFund);
    }
  }
  playNow(data) {
    var endDate = new Date(data.endDate);
    endDate = endDate.toString();
    var startDate = new Date(data.startDate);
    startDate = startDate.toString();

    window.webengage.track("Play Now Clicked", {
      "Contest Name": data.contestName,
      "Prize pool": data.winningAmount,
      "Started At": new Date(startDate),
      "Ends in": new Date(endDate),
      "Number of participants": Number(data.numOfParticipation),
    });
    axios
      .post(
        baseUrl + "api/updatePlayNowCondition",
        { contest_id: data.contestId },
        config
      )
      .catch();
  }
  participate(id, virtualFund) {
    const { user } = this.props.auth;
    if (
      this.state.coupon === "" ||
      (this.state.coupon === undefined && this.state.couponRequired === "yes")
    ) {
      toast.error("Please enter entry code", toastStyles);
      return false;
    }
    if (this.state.isEntryFees === "yes") {
      // $('#participateModal').modal('hide');
      this.setState({ isEntryFeesModaL: true });
      return false;
    } else {
      this.setState({ participateBtnDisable: true });
      var sendData = {
        contest_id: id,
        coupon: this.state.coupon,
        virtualFund: virtualFund,
      };
      axios
        .post(baseUrl + "api/participateCondition", sendData, config)
        .then((res) => {
          this.setState({
            participateBtnDisable: false,
          });
          if (res.data.status) {
            this.setState({ status: "active" });
            axios
              .post(baseUrl + "api/contestByID-data", { id: id }, config)
              .then((res) => {
                // console.log("res.data.data",res.data.data.item);
                if (res.data.data.item) {
                  const data = res.data.data.item;
                  var endDate = new Date(data.endDate);
                  endDate = endDate.toISOString();
                  var startDate = new Date(data.startDate);
                  startDate = startDate.toISOString();
                  window.webengage.track("Participation Completed", {
                    "Category Name": "Live",
                    "Contest Name": data.contestName,
                    "Prize pool": data.winningAmount,
                    "Started At": new Date(startDate),
                    "Ends in": new Date(endDate),
                    "Number of participants": Number(data.numOfParticipation),
                    "Coupon code": res.data.data,
                  });
                }
              });
            // $('#participateModal').modal('hide');
            toast.success(res.data.message, toastStyles);
          } else {
            toast.error(res.data.message, toastStyles);
          }
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        })
        .catch();
    }
  }
  participate22(contestId, virtualFund) {
    var contestId = this.props.match.params.id;
    const { user } = this.props.auth;
    var sendData = {
      contest_id: contestId,
      coupon: this.state.coupon,
      virtualFund: virtualFund,
    };
    axios
      .post(baseUrl + "api/participateCondition", sendData, config)
      .then((res) => {
        this.setState({
          participateBtnDisable: false,
        });
        if (res.data.status) {
          this.setState({
            status: "active",
            show: false,
          });
          // $('#participateModal').modal('hide');
          toast.success(res.data.message, toastStyles);
        } else {
          toast.error(res.data.message, toastStyles);
        }
        // setTimeout(function () {
        //     window.location.reload();
        // }, 1000);
        // console.log("this.state.contestCreateType=",this.state.contestCreateType);
        var exchangePageUrl = "/exchange/";
        if (this.state.contestCreateType === "coin") {
          exchangePageUrl = "/coin-exchange/";
        } else if (this.state.contestCreateType === "price") {
          exchangePageUrl = "/price-exchange/";
        } else if (this.state.contestCreateType === "forcasting") {
          exchangePageUrl = "/question/";
        }
        this.setState({ exchangePageUrl: exchangePageUrl });
        if (this.state.exchangeType != null) {
          window.location.href =
            exchangePageUrl +
            contestId +
            "/" +
            this.state.exchangeType.toUpperCase() +
            "/" +
            this.state.pairRealName +
            this.state.urltemp;
        } else {
          toast.error("Something went wrong", toastStyles);
        }
      })
      .catch();
  }
  onChange = (e) => {
    if (e.target.id === "coupon") {
      this.setState({ coupon: e.target.value });
    }
  };
  handleRewardWalletCheck = (e) => {
    // var bonusper = this.state.entryFee * 50 / 100;
    // bonusper = (bonusper>this.state.bonus)  ? this.state.bonus : bonusper;
    // var totalde = this.state.entryFee - bonusper;

    // if (this.state.rewardWalletChecked == false) {
    //     this.setState({ checkBox: true, bonusper: bonusper, totalde: totalde });
    // } else {

    //     this.setState({ checkBox: false, bonusper: 0, totalde: 0 });
    // }
    this.setState({ rewardWalletChecked: !this.state.rewardWalletChecked });
    this.calculateIt(
      this.state.cashWalletChecked,
      this.state.winningWalletChecked,
      !this.state.rewardWalletChecked
    );
  };

  handleCashWalletCheck = (e) => {
    // var bonusper = this.state.entryFee * 50 / 100;
    // bonusper = (bonusper>this.state.bonus)  ? this.state.bonus : bonusper;
    // var totalde = this.state.entryFee - bonusper;

    // if (this.state.rewardWalletChecked == false) {
    //     this.setState({ checkBox: true, bonusper: bonusper, totalde: totalde });
    // } else {

    //     this.setState({ checkBox: false, bonusper: 0, totalde: 0 });
    // }
    this.setState({ cashWalletChecked: !this.state.cashWalletChecked });
    this.calculateIt(
      !this.state.cashWalletChecked,
      this.state.winningWalletChecked,
      this.state.rewardWalletChecked
    );
  };

  handleWinningWalletCheck = (e) => {
    // var bonusper = this.state.entryFee * 50 / 100;
    // bonusper = (bonusper>this.state.bonus)  ? this.state.bonus : bonusper;
    // var totalde = this.state.entryFee - bonusper;

    // if (this.state.rewardWalletChecked == false) {
    //     this.setState({ checkBox: true, bonusper: bonusper, totalde: totalde });
    // } else {

    //     this.setState({ checkBox: false, bonusper: 0, totalde: 0 });
    // }
    this.setState({ winningWalletChecked: !this.state.winningWalletChecked });
    this.calculateIt(
      this.state.cashWalletChecked,
      !this.state.winningWalletChecked,
      this.state.rewardWalletChecked
    );
  };

  calculateIt = (cashCheck, winningCheck, rewardCheck) => {
    // console.log("cashWalletChecked",cashCheck);
    // console.log("winningWalletChecked",winningCheck);
    // console.log("rewardWalletChecked",rewardCheck);
    var remainingAmount = this.state.entryFee;
    var rewardWalletDeduct = 0;
    var winningWalletDeduct = 0;
    var cashWalletDeduct = 0;

    if (rewardCheck) {
      var rewardWalletDeduct = (remainingAmount * 50) / 100;
      rewardWalletDeduct =
        rewardWalletDeduct > this.state.bonus
          ? this.state.bonus
          : rewardWalletDeduct;
      var remainingAmount = remainingAmount - rewardWalletDeduct;
    }

    if (winningCheck) {
      var winningWalletDeduct = remainingAmount;
      winningWalletDeduct =
        parseInt(winningWalletDeduct) >
        parseInt(this.state.winningWalletBalance)
          ? this.state.winningWalletBalance
          : winningWalletDeduct;

      var remainingAmount = remainingAmount - winningWalletDeduct;
    }

    if (cashCheck) {
      var cashWalletDeduct = remainingAmount;
      cashWalletDeduct =
        cashWalletDeduct > this.state.cashWalletBalance
          ? this.state.cashWalletBalance
          : cashWalletDeduct;
      var remainingAmount = remainingAmount - cashWalletDeduct;
    }

    // console.log("rewardWalletDeduct",rewardWalletDeduct);
    // console.log("winningWalletDeduct",winningWalletDeduct);
    // console.log("cashWalletDeduct",cashWalletDeduct);

    this.setState({
      rewardWalletDeduct: rewardWalletDeduct,
      winningWalletDeduct: winningWalletDeduct,
      cashWalletDeduct: cashWalletDeduct,
    });
  };

  getData() {
    var currentTime = moment().utcOffset("+05:30").format("HH:mm");
    var endTime = moment()
      .utcOffset("+05:30")
      .add(1, "minutes")
      .format("HH:mm");
    const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken });
    var collectThis = this;
    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("config3rdphase");
    });
    socket.on("3rdPhaseConfig", function (apiRespData) {
      // console.log("apiRespData==",apiRespData);
      if (socket.id == collectThis.state.currentSocketId) {
        var arr = [];
        arr["account"] = apiRespData.data[0].account;
        arr["transaction"] = apiRespData.data[0].transaction;
        collectThis.setState({ thirdPhaseConfig: arr });
      }
    });
    axios
      .post(
        baseUrl + "api/contestByID-data",
        { id: this.props.match.params.id },
        config
      )
      .then((res) => {
        // console.log("ye contestka view hai",res.data.data);
        if (res.data.data.item) {
          var arrData = res.data.data.item;
          var arr = [];
          var arr1 = [];
          // if(arrData.winningAmount > 0){
          arr = arrData.levels.split(",");
          if (arrData.winningPrize.length > 0) {
            arr1 = arrData.winningPrize.split(",");
          } else {
            arr1 = [arrData.winningPrize];
          }
          //  console.log("arr1====",arrData.winningPrize);
          // }
          // console.log("arrData===",arrData);
          let cleanText = arrData.description.replace(`/</?[^>]+(>|$)/g`, "");
          this.setState({
            records: res.data.data,
            contestLogo: arrData.contestLogo,
            contestName: arrData.contestName,
            startDate: arrData.startDate,
            startTime: arrData.startTime,
            endDate: arrData.endDate,
            endTime: arrData.endTime,
            entryFee: arrData.entryFee,
            virtualFund: arrData.contestVirtualFund,
            winningAmount: arrData.winningAmount,
            winning_distribution_type: arrData.winning_distribution_type,
            winningAmountInUsd: arrData.winningAmountInUsd,
            contestStatus: arrData.contestStatus,
            description: arrData.description,
            heading: arrData.heading,
            about: arrData.about,
            notes: arrData.notes,
            levels: arr,
            winningPrize: arr1,
            numOfParticipation: arrData.numOfParticipation,
            currentStatus: arrData.currentStatus,
            max_particepate: arrData.max_particepate,
            entryFeePoints: arrData.entryFeePoints,
            isEntryFees: arrData.isEntryFees,
            // contestTypePast:arrData.pastContestStatus,
            couponRequired: arrData.couponRequired,
            contestTypeStatus: arrData.contestTypeStatus,
            exchangeType: arrData.exchangeTypeName,
            winninghideshow: arrData.winninghideshow,
            contestCreateType: arrData.contestType,
            entryFeeTypeRequired: arrData.entryFeeTypeRequired,
            winning_distribution_type: arrData.winning_distribution_type,
            priceDistributionDateTime: arrData.priceDistributionDateTime,
            bufferTime: arrData.bufferTime,
            remainingPriceDistribution: arrData.remainingPriceDistribution,
          });
          // console.log("arrData.contestTypearrData.contestType=", arrData.contestType);
          // console.log("this.state===",this.state);
          var exchangePageUrl = "/exchange/";
          if (this.state.contestCreateType === "coin") {
            exchangePageUrl = "/coin-exchange/";
          } else if (this.state.contestCreateType === "price") {
            exchangePageUrl = "/price-exchange/";
          } else if (this.state.contestCreateType === "forcasting") {
            exchangePageUrl = "/question/";
          }
          this.setState({ exchangePageUrl: exchangePageUrl });
        }
        // webenagage
        // console.log("this.state.endDate=====",this.state.endDate);
        var endDate = new Date(this.state.endDate);
        endDate = endDate.toISOString();
        var startDate = new Date(this.state.startDate);
        startDate = startDate.toISOString();
        // console.log("Virtual Trading_Contest Details Viewed==",this.state.currentStatusLive);
        if (
          this.state.contestTypeStatus !== "live" &&
          this.state.contestTypeStatus !== "upcoming"
        ) {
          this.setState({ contestTypeStatus: "Past" });
        }
        // window.webengage.track('Virtual Trading_Contest Details Viewed', {
        //     'Category Name':this.state.contestTypeStatus,
        //     'Contest Name': this.state.contestName,
        //     'Prize pool':this.state.winningAmount,
        //     'Started At':new Date(startDate),
        //     'Ends in':new Date(endDate),
        //     'Number of participants':Number(this.state.numOfParticipation),
        //     'Current Status':this.state.contestTypeStatus
        // });
        // console.log("ye contestka view hai",res.data.data);
        //
      })
      .catch();
    axios
      .post(baseUrl + "api/profile-data", {}, config)
      .then((res) => {
        let winningCash = 0;
        let cashWalletBalance = 0;
        if (res.data.data.winningCash != null) {
          winningCash = res.data.data.winningCash;
        }
        if (res.data.data.cashWalletBalance != null) {
          cashWalletBalance = res.data.data.cashWalletBalance;
        }
        this.setState({
          bonus: res.data.data.bonus,
          winningWalletBalance: res.data.data.winningamount,
          cashWalletBalance: cashWalletBalance,
          userAvaliablePoints: res.data.data.totalPoints,
          winningCash: winningCash,
        });
      })
      .catch();
    // console.log("dddddddddddddd=");
    axios
      .post(
        baseUrl + "api/liveContestById",
        { contestId: this.props.match.params.id },
        config
      )
      .then((res) => {
        console.log("res.data.data[0].pairRealName==", res.data.data[0]);
        if (res.data.data[0] && res.data.data[0].contestId !== null) {
          this.setState({
            currentStatusLive: res.data.data[0].contestTypeStatus,
            pairRealName: res.data.data[0].pairRealName,
            playNow: res.data.data[0].playNow,
            contestType: "live",
          });
        } else {
          this.setState({ contestTypePast: true });
        }
      })
      .catch();
    // axios
    //     .post(baseUrl + "api/leaderboard-winner-data", { contestId: this.props.match.params.id }, config)
    //     .then(res => {
    //         // console.log("res.data.data===",res.data.data);
    //         if(res.data.data){
    //             this.setState({ leaderboard: res.data.data })
    //         }
    //         // console.log("res.data.data==",res.data.data);

    //     })
    //     .catch()
    axios
      .post(
        baseUrl + "api/leaderboard-data",
        { contestId: this.props.match.params.id },
        config
      )
      .then((res) => {
        console.log(res, "resssllslslsl");
        this.setState({
          participant: res.data.data,
          leaderboard: res.data.data,
        });
      })
      .catch();
    axios
      .post(
        baseUrl + "api/prediction-order",
        { contestId: this.props.match.params.id },
        config
      )
      .then((res) => {
        // console.log("trading-res.data", res.data);
        this.setState({ predictionOrder: res.data });
      })
      .catch();
  }

  showHtml = () => {
    var collectThis = this;
    const html = [];
    var winningPrize = this.state.winningPrize;
    this.state.levels.map(function (value, i) {
      html.push(
        <>
          <tr>
            <th style={{ width: "150px" }}>{i + 1}</th>
            <th className="tr-center">{value}</th>
            {collectThis.state.winning_distribution_type != "pool" && (
              <th className="tr-center">{winningPrize[i]}</th>
            )}
          </tr>
        </>
      );
    });
    return html;
  };

  hideModal = () => {
    this.setState({ isEntryFeesModaL: false });
  };

  contestPayment = () => {
    let data;
    if (this.state.isEntryFees === "yes") {
      data = {
        coupon: this.state.coupon,
        contestId: this.props.match.params.id,
        pointsRequire: this.state.poitsRequire,
        entryFeeTypeRequired: this.state.entryFeeTypeRequired,
      };
    } else {
      data = {
        contestId: this.props.match.params.id,
        pointsRequire: this.state.poitsRequire,
        entryFeeTypeRequired: this.state.entryFeeTypeRequired,
      };
    }
    axios.post(baseUrl + "api/pay-contest-fee", data, config).then((res) => {
      var resp = res.data;
      if (resp.success === true) {
        this.setState({ isEntryFeesModaL: false });
        if (this.state.isEntryFees === "yes") {
          this.setState({ participateBtnDisable: true });
          var sendData = {
            contest_id: this.props.match.params.id,
            coupon: this.state.coupon,
            virtualFund: this.state.virtualFund,
          };
          axios
            .post(baseUrl + "api/participateCondition", sendData, config)
            .then((res) => {
              this.setState({
                participateBtnDisable: false,
              });
              if (res.data.status) {
                this.setState({
                  status: "active",
                  show: false,
                });
                // $('#participateModal').modal('hide');
                toast.success(res.data.message, toastStyles);
              } else {
                toast.error(res.data.message, toastStyles);
              }
              setTimeout(function () {
                window.location.reload();
              }, 1000);
            })
            .catch();
        } else {
          this.participate22(this.state.id, this.state.virtualFund);
        }
      } else {
        this.setState({ isEntryFeesModaL: true });
        toast.error(resp.message);
      }
    });
  };

  render() {
    const { user } = this.props.auth;
    return (
      <>
        <Navbar
          urlPath={false}
          symbol={false}
          thirdPhaseConfig={this.state.thirdPhaseConfig}
        />
        <Sidebar />

        <div
          className="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Contest Rules
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div
                className="modal-body rules_list"
                dangerouslySetInnerHTML={{ __html: this.state.description }}
              ></div>
            </div>
          </div>
        </div>
        <div className="in_page">
          <div className="container">
            <div className="crypt-market-status2  ">
              <div className="row sm-gutters row_d p-3">
                <div className="col-lg-6 col_d mt-2 pr-lg-5 ">
                  <div className="row ">
                    <div className="col-6">
                      <h5 className="ttc">{this.state.contestName}</h5>
                    </div>
                    <div className="col-6 tr mb-3">
                      <a
                        className="view_dital"
                        href="javascript:void(0)"
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        Contest Rules
                      </a>
                    </div>
                  </div>
                  {this.state.contestCreateType === "coin" && (
                    <div className="pool_amount_box mb-2">
                      <div className="">Pool Amount</div>
                      <div className="ml-auto">
                        ₹{" "}
                        {this.state.entryFeePoints *
                          this.state.numOfParticipation}
                      </div>
                    </div>
                  )}
                  {this.state.contestCreateType === "price" && (
                    <div className="pool_amount_box mb-2">
                      <div className="">Pool Amount</div>
                      <div className="ml-auto">
                        ₹{" "}
                        {this.state.entryFeePoints *
                          this.state.numOfParticipation}
                      </div>
                    </div>
                  )}

                  {this.state.contestCreateType === "forcasting" && (
                    <div className="pool_amount_box mb-2">
                      <div className="">Pool Amount</div>
                      <div className="ml-auto">
                        ₹{" "}
                        {this.state.entryFeePoints *
                          this.state.numOfParticipation}
                      </div>
                    </div>
                  )}

                  <div className="row ">
                    <div className="col-5 pt-1">
                      <b>Prize Fund</b>
                    </div>
                    {this.state.winninghideshow === "no" && (
                      <div className="col-7 tr mb-2">
                        <h5 className="ine_hadding">
                          {this.state.winningAmount}
                          {this.state.winning_distribution_type == "byPoints"
                            ? " Points"
                            : ""}
                          {this.state.winning_distribution_type == " cash"
                            ? " ₹"
                            : ""}
                          {this.state.winning_distribution_type == " pool"
                            ? " ₹"
                            : ""}
                          {this.state.winning_distribution_type == " byCoins"
                            ? "Coins"
                            : ""}
                        </h5>
                        {/* <h5 className="ine_hadding">{this.state.winningAmountInUsd} USD</h5> */}
                      </div>
                    )}

                    {/* <div className="col-5 pt-1">
							     <b>Entry Fee</b>
							  </div>
							  <div className="col-7 tr mb-2">
							     <h5 className="ine_hadding">{this.state.entryFee} INR</h5>
							  </div> */}
                  </div>

                  <div className=" tr">
                    {this.state.contestTypeStatus == "upcoming" && (
                      <div className="play_btn_flef">
                        {this.state.couponRequired === "yes" ? (
                          this.state.currentStatus == "1" ? (
                            <span className="alert alert-success">
                              Already Participated
                            </span>
                          ) : this.state.numOfParticipation !=
                            this.state.max_particepate ? (
                            <button
                              type="button"
                              className="btn btn_man p_button"
                              onClick={() => this.participatedata(this.state)}
                              data-toggle="modal"
                              data-target="#participateModal"
                            >
                              Participate Now{" "}
                            </button>
                          ) : (
                            "Participation limit exceeded"
                          )
                        ) : this.state.currentStatus == "1" ? (
                          <span className="alert alert-success">
                            Already Participated
                          </span>
                        ) : this.state.numOfParticipation !=
                          this.state.max_particepate ? (
                          <button
                            type="button"
                            className="btn btn_man p_button"
                            onClick={() => this.participatedata22(this.state)}
                          >
                            Participate Now
                          </button>
                        ) : (
                          "Participation limit exceeded"
                        )}
                        {/* {
                                // this.state.couponRequired ==='yes'?this.state.currentStatus== 1?<span className="alert alert-success">Already Participated</span>:this.state.numOfParticipation!= this.state.max_particepate ?<button type="button" className="btn btn_man p_button"  onClick={() => this.participatedata(this.state)} data-toggle="modal" data-target="#participateModal" >Participate Now</button>:<span className="alert alert-danger">Participation limit exceeded</span>:<span className="alert alert-success">Already Participated</span>
                                this.state.currentStatus == 1 ?
    this.state.playNow== 'yes'? <Link className="play-now btn btn_man" to={this.state.exchangePageUrl + this.state.contestId+"/"+this.state.exchangeType.toUpperCase()+"/"+this.state.pairRealName+this.state.urltemp} onClick={() => this.playNow(this.state)}><i className="las la-trophy"></i>Going On</Link>:<Link className="play-now btn btn_man" to={this.state.exchangePageUrl + this.state.contestId+"/"+this.state.exchangeType.toUpperCase()+"/"+this.state.pairRealName+this.state.urltemp} onClick={() => this.playNow(this.state)}><i className="las la-trophy"></i>Play Now </Link>
    : this.state.numOfParticipation!= this.state.max_particepate ? <button type="button" className="btn btn_man p_button"  onClick={() => this.participatedata22(this.state)} >Participate Now </button> : <span className="alert alert-danger">Participation limit exceeded</span>
                                }   */}
                      </div>
                    )}
                    {this.state.contestTypeStatus === "live" && (
                      <div className="  play_btn_flef ">
                        {this.state.couponRequired === "yes" ? (
                          this.state.currentStatus == 1 ? (
                            this.state.playNow == "yes" ? (
                              <Link
                                className="play-now btn btn_man"
                                to={
                                  this.state.exchangePageUrl +
                                  this.state.contestId +
                                  "/" +
                                  this.state.exchangeType.toUpperCase() +
                                  "/" +
                                  this.state.pairRealName +
                                  this.state.urltemp
                                }
                                onClick={() => this.playNow(this.state)}
                              >
                                <i className="las la-trophy"></i>Going On
                              </Link>
                            ) : (
                              <Link
                                className="play-now btn btn_man"
                                to={
                                  this.state.exchangePageUrl +
                                  this.state.contestId +
                                  "/" +
                                  this.state.exchangeType.toUpperCase() +
                                  "/" +
                                  this.state.pairRealName +
                                  this.state.urltemp
                                }
                                onClick={() => this.playNow(this.state)}
                              >
                                <i className="las la-trophy"></i>Play Now
                              </Link>
                            )
                          ) : this.state.numOfParticipation !=
                            this.state.max_particepate ? (
                            <button
                              type="button"
                              className="btn btn_man p_button"
                              onClick={() => this.participatedata(this.state)}
                              data-toggle="modal"
                              data-target="#participateModal"
                            >
                              Participate Now{" "}
                            </button>
                          ) : (
                            <span className="alert alert-danger">
                              Participation limit exceeded
                            </span>
                          )
                        ) : this.state.currentStatus == 1 ? (
                          this.state.playNow == "yes" ? (
                            <Link
                              className="play-now btn btn_man"
                              to={
                                this.state.exchangePageUrl +
                                this.state.contestId +
                                "/" +
                                this.state.exchangeType.toUpperCase() +
                                "/" +
                                this.state.pairRealName +
                                this.state.urltemp
                              }
                              onClick={() => this.playNow(this.state)}
                            >
                              <i className="las la-trophy"></i>Going On
                            </Link>
                          ) : (
                            <Link
                              className="play-now btn btn_man"
                              to={
                                this.state.exchangePageUrl +
                                this.state.contestId +
                                "/" +
                                this.state.exchangeType.toUpperCase() +
                                "/" +
                                this.state.pairRealName +
                                this.state.urltemp
                              }
                              //onClick={() => this.playNow(this.state)}
                            >
                              <i className="las la-trophy"></i>Play Now
                            </Link>
                          )
                        ) : this.state.numOfParticipation !=
                          this.state.max_particepate ? (
                          <button
                            type="button"
                            className="btn btn_man p_button"
                            onClick={() => this.participatedata22(this.state)}
                          >
                            Participate Now{" "}
                          </button>
                        ) : (
                          <span className="alert alert-danger">
                            Participation limit exceeded
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 col_d ">
                  <div className="lilogo">
                    <img
                      src={baseUrl + "static/logo/" + this.state.contestLogo}
                      alt="Logo"
                      className="c_logo"
                    />

                    {/* <ul>
                                        <li className="tc"> 
                                        <img src="/img/banner-logo.png" alt="Logo" className="c_logo" />
                                        <img src={baseUrl+"static/logo/" + this.state.contestLogo} alt="Logo" className="c_logo" />

                                        
                                        </li>
                                        <li className="border_li"> {this.state.winningAmount} INR<br />PRIZE POOL</li>
                                    </ul>  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-md-4">
                <div className="crypt-market-status2 mt-4 tc_box">
                  <div className="pt-3 pl-3 pr-3">
                    <div className="row">
                      <div className="col-6 mb-2">
                        <b className="d_hadding">Participants</b>
                      </div>
                      <div className="col-6 mb-2 tr">
                        <div className="d_value2">
                          {this.state.numOfParticipation}
                        </div>
                      </div>
                      <div className="col-6 mb-2">
                        <b className="d_hadding">Start</b>
                      </div>
                      <div className="col-6 mb-2 tr">
                        <div className="d_value2">
                          {moment
                            .utc(this.state.startDate)
                            .format("YYYY-MM-DD HH:mm")}
                          {/* {this.state.startDate} {this.state.startTime} */}
                        </div>
                      </div>
                      <div className="col-6 ">
                        <b className="d_hadding">End</b>
                      </div>
                      <div className="col-6 mb-2 tr">
                        <div className="d_value2">
                          {moment
                            .utc(this.state.endDate)
                            .format("YYYY-MM-DD HH:mm")}
                          {/* {this.state.endDate} {this.state.endTime} */}
                        </div>
                      </div>
                      <div className="col-6 ">
                        <b className="d_hadding">Buffer Time</b>
                      </div>
                      <div className="col-6 mb-2 tr">
                        <div className="d_value2">
                          {this.state.bufferTime} Min
                          {/* {this.state.endDate} {this.state.endTime} */}
                        </div>
                      </div>
                      <div className="col-6 ">
                        <b className="d_hadding">Price Distribution Time</b>
                      </div>
                      <div className="col-6 mb-2 tr">
                        <div className="d_value2">
                          {moment
                            .utc(this.state.priceDistributionDateTime)
                            .format("YYYY-MM-DD HH:mm")}
                          {/* {this.state.endDate} {this.state.endTime} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.winninghideshow === "no" && (
                    <div className="p-3">
                      <table className="table mb-0">
                        <tbody>
                          <tr className="winners_table2">
                            <th className="th">Rank</th>
                            <th className="th tr-center"> Winning Amount</th>
                          </tr>
                        </tbody>
                        {/* {this.showHtml()} */}
                      </table>
                      <div className="winners_table">
                        <table className="table ">{this.showHtml()}</table>
                      </div>
                    </div>
                  )}

                  {this.state.winning_distribution_type == "pool" && (
                    <div className="p-3">
                      <b>
                        Rest of the winners will get ₹{" "}
                        {this.state.remainingPriceDistribution}
                      </b>
                    </div>
                  )}
                  {/*<div className="pl-2 pl-md-3 pr-2 pr-md-3 pb-3">
                                    <h5>About</h5>
                                    <p> {this.state.about}
                                    </p>
                                </div>*/}
                </div>
              </div>
              <div className="col-md-8 mt-3 mt-sm-0">
                <div className="crypt-market-status2 mt-4 p-2 p-md-3">
                  <ul className="nav contatcs-tab pb-3" id="crypt-tab">
                    <li className="nav-item">
                      <a
                        className="active"
                        data-toggle="tab"
                        href="#Leaderboard"
                      >
                        Leaderboard
                      </a>
                    </li>
                    <li className="nav-item">
                      <a data-toggle="tab" href="#Leaderboard2">
                        Participants
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div id="Leaderboard" className="tab-pane active">
                      <Leaderboard
                        leaderboard={this.state.leaderboard}
                        contestCreateType={this.state.contestCreateType}
                        predictionOrder={this.state.predictionOrder}
                        winning_distribution_type={
                          this.state.winning_distribution_type
                        }
                      />
                    </div>
                    <div id="Leaderboard2" className="tab-pane fade">
                      <Participant
                        participant={this.state.participant}
                        contestCreateType={this.state.contestCreateType}
                        predictionOrder={this.state.predictionOrder}
                        winning_distribution_type={
                          this.state.winning_distribution_type
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade "
          id="participateModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content mx400">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Please enter entry code
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="form-group p-3">
                {this.state.couponRequired === "no" && (
                  <label>Entry Code</label>
                )}
                {this.state.couponRequired === "yes" && (
                  <label>
                    Entry Code<span className="text-danger"> *</span>
                  </label>
                )}

                <input
                  onChange={this.onChange}
                  className="form-control"
                  value={this.state.coupon}
                  id="coupon"
                  type="text"
                  placeholder="Coupon"
                  required
                />
                {this.state.couponRequired === "no" && (
                  <label className="form-check-label" for="flexCheckChecked">
                    <br />
                    <span className="text-danger">
                      Note: Please click on skip Button
                    </span>
                  </label>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-border"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn_man"
                  onClick={() =>
                    this.participate(
                      this.state.contestId,
                      this.state.virtualFund
                    )
                  }
                >
                  {this.state.couponRequired === "yes" && "Participate"}
                  {this.state.couponRequired === "no" && "Skip"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.isEntryFeesModaL}
          onHide={this.hideModal}
          dialogClassName="modal-90w mx400"
          aria-labelledby="example-custom-modal-styling-title"
          className="fade modal entry-funds"
        >
          <Modal.Header className="justify-content-between align-items-center">
            <Modal.Title id="example-custom-modal-styling-title">
              <h6 className="modal-title" id="exampleModalLabel">
                Add{" "}
                {this.state.entryFeeTypeRequired == "points" &&
                  "Points To Enter The Contest"}
                {this.state.entryFeeTypeRequired == "cash" &&
                  "Funds To Enter The Contest"}
              </h6>
            </Modal.Title>
            {this.state.entryFeeTypeRequired == "cash" &&
              this.state.cashWalletBalance < this.state.poitsRequire && (
                <Link
                  className="btn btn_man"
                  to={
                    this.state.urltemp !== ""
                      ? "/addCash" + this.state.urltemp
                      : "/addCash"
                  }
                >
                  Add Funds
                </Link>
              )}
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              {this.state.poitsRequire > 0 && (
                <label className="m-0">
                  {this.state.entryFeeTypeRequired == "cash"
                    ? "Funds"
                    : "Points"}{" "}
                  Required to Participate: ₹ {this.state.poitsRequire}
                  <span className="text-danger"> *</span>
                </label>
              )}
            </div>
            <div className="form-group">
              {this.state.entryFeeTypeRequired == "cash" ? (
                <lable className="m-0">
                  Avaliable Funds: ₹{" "}
                  {(
                    this.state.cashWalletBalance +
                    parseFloat(this.state.winningCash)
                  ).toFixed(2)}{" "}
                </lable>
              ) : (
                <lable>
                  Avaliable Points: {this.state.userAvaliablePoints}
                </lable>
              )}
            </div>
            {this.state.entryFeeTypeRequired == "points" &&
              this.state.userAvaliablePoints < this.state.poitsRequire && (
                <div className="form-group">
                  <span className="text-danger">
                    Not enough points to participate:{" "}
                    {parseFloat(this.state.poitsRequire) -
                      parseFloat(this.state.userAvaliablePoints)}
                  </span>
                </div>
              )}
            {this.state.entryFeeTypeRequired == "cash" &&
              this.state.cashWalletBalance < this.state.poitsRequire && (
                <div className="form-group">
                  {this.state.cashWalletBalance + this.state.winningCash <
                    this.state.poitsRequire && (
                    <span className="text-danger">
                      Not enough funds to participate: ₹{" "}
                      {(
                        parseFloat(this.state.poitsRequire) -
                        (parseFloat(this.state.cashWalletBalance) +
                          parseFloat(this.state.winningCash))
                      ).toFixed(2)}
                    </span>
                  )}
                </div>
              )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.hideModal}>
              Close
            </Button>
            {this.state.entryFeeTypeRequired == "points" &&
              this.state.userAvaliablePoints >= this.state.poitsRequire && (
                <button
                  variant="primary"
                  className="btn btn_man"
                  disabled={this.state.participateBtnDisable}
                  onClick={() =>
                    this.contestPayment(this.state.id, this.state.virtualFund)
                  }
                >
                  {this.state.poitsRequire > 0 && "Pay"}
                </button>
              )}
            {this.state.entryFeeTypeRequired == "cash" &&
              this.state.cashWalletBalance + this.state.winningCash >=
                this.state.poitsRequire && (
                <button
                  variant="primary"
                  className="btn btn_man"
                  disabled={this.state.participateBtnDisable}
                  onClick={() =>
                    this.contestPayment(
                      this.state.contestId,
                      this.state.virtualFund
                    )
                  }
                >
                  {this.state.poitsRequire > 0 && "Pay"}{" "}
                </button>
              )}
          </Modal.Footer>
        </Modal>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}
TradingContest.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  records: state.records,
});
export default connect(mapStateToProps)(TradingContest);
